export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-facebook-6381de8178596beaf9bde779c02bf786.svg";